
import React, {useEffect, useState } from 'react';
import {NavLink,  Link, } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { baseURL,imageURL }  from './MyApi';


const languages = [
	{
	  code: 'ar',
	  name: 'العربية',
	  dir: 'rtl',
	  country_code: 'sa',
	},

	{
		code: 'fr',
		name: 'Français',
		dir: 'ltr',
		country_code: 'fr',
	  }
  ]
  
  const GlobeIcon = ({ width = 30, height = 30 }) => (
	<svg
	  xmlns="http://www.w3.org/2000/svg"
	  width={width}
	  height={height}
	  fill="currentColor"
	  className="bi bi-globe"
	  viewBox="0 0 16 16"
	>
	  <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z" />
	</svg>
  )

  const TypeChartIcon = ({ width = 30, height = 30 }) => (
	<svg
	  xmlns="http://www.w3.org/2000/svg"
	  width={width}
	  height={height}
	  fill="currentColor"
	  className="bi bi-bar-chart-box-line"
	  viewBox="0 0 24 21"
	>
	<path fill="none" d="M0 0h24v24H0z"/><path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h16V5H4zm3 8h2v4H7v-4zm4-6h2v10h-2V7zm4 3h2v7h-2v-7z"/>
	</svg>
  )

function Header () {
	const { t,i18n } = useTranslation()

	const changeLanguage = (lng) => {
		i18next.changeLanguage(lng);
		window.location.reload();
		
	   }


	const currentLanguageCode = i18n.language
	const currentLanguage = languages.find((l) => l.code === currentLanguageCode)

	const [libelle, setLibelle] = useState(null);
	const [logo, setLogo] = useState(null);

  
// ----------- Get the municipalite Name from URL Query Params START-------------
const search = window.location.search;
const params = new URLSearchParams(search);
const tenant = params.get('tenant');
// ----------- Get the municipalite Name from URL Query Params END-------------

const FavIcon = document.getElementById("favicon");




	useEffect(() => {
		
		fetch(baseURL + tenant + '/getInfosForHeader', {
			"method": "GET",
			"headers": {
			  "content-type": "application/json",
			  "accept": "application/json"
			},
		  })
		  .then(response => response.json())
		  .then(response => {

			  setLibelle(currentLanguageCode === 'fr'? response.libelle:response.libelle_ar);
			  setLogo(imageURL+response.logo)

			
		  })
		  .catch(err => {
			console.log(err);
		  })


		
	  document.body.dir = currentLanguage.dir || 'rtl'
	  document.title = t('app_title', { libelle })
	  FavIcon.href=logo



	  
	}, [tenant ,logo , FavIcon,libelle , currentLanguage, currentLanguageCode, t]);
  

		return ( 
			
				<div className='page-wrapper'>

					<header className='main-header header-style-five'>


						<div className='header-top'>
							<div className='auto-container'>
								<div className='inner-container clearfix'>
									<div className='top-left'>
										<ul className='contact-list clearfix'>
											<li><i className='fa fa-hashtag'></i> {libelle}</li>

										</ul>
									</div>
									
									
									


									<div className='top-right'>

									<span className='top-right-with-padd'>

											<TypeChartIcon />
											<select id="chartTypeValue">
												<option value="line">line</option>
												<option value="spline">spline</option>
												<option value="area">area</option>
												<option value="areaspline">areaspline</option>
												<option value="bar">bar</option>
												<option value="column">column</option>
											</select>	
									</span>


           
              <GlobeIcon />
              {languages.map(({ code, name, country_code }) => (
                <div className='lngBtn' key={country_code}>
                  <button
                    className="dropdown-item" onClick={() => changeLanguage(code)}
                      disabled={code === currentLanguageCode} >
                    <span style={{
                        opacity: currentLanguageCode === code ? 0.5 : 1,
                      }}
                    ></span>
                    {name}
                  </button>
                </div>
              ))}
          
		  
         

									</div>
								</div>
							</div>
						</div>

						<div className='header-upper'>
							<div className='auto-container'>
								<div className='clearfix'>

									<div className='pull-left logo-box'>
										<div className='logo'>
											<Link to={'/?tenant='+tenant}><img src='../assets/images/logo.png' alt='' title='' /></Link>
										</div>
									</div>

									<div className='nav-outer clearfix'>


										<nav className='main-menu navbar-expand-md'>
											<div className='navbar-header'>
												<button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
													<span className='icon-bar'></span>
													<span className='icon-bar'></span>
													<span className='icon-bar'></span>
												</button>
											</div>

											<div className='navbar-collapse collapse clearfix' id='navbarSupportedContent'>
												<ul className='navigation clearfix'>
													<li><NavLink to={'/municipalite?tenant='+tenant} activeclassname='active'><i className='icon flaticon-bank-building'></i> {t('municipalite')} </NavLink></li>
												    <li><NavLink to={'/recette?tenant='+tenant} activeclassname='active'><i className='icon flaticon-money-bag'></i> {t('budget_recette')} </NavLink></li>
													<li><NavLink to={'/recette_mensuelle?tenant='+tenant} activeclassname='active'><i className='icon flaticon-budget'></i> {t('recette_mensuelle')} </NavLink></li>
													<li><NavLink to={'/depense?tenant='+tenant} activeclassname='active'><i className='icon flaticon-money'></i> {t('budget_depense')} </NavLink></li>
													<li><NavLink to={'/depense_mensuelle?tenant='+tenant} activeclassname='active'><i className='icon flaticon-budget-1'></i> {t('depense_mensuelle')} </NavLink></li>
													<li><NavLink to={'/indicateurs?tenant='+tenant} activeclassname='active'><i className='icon flaticon-target'></i> {t('indicateurs')} </NavLink></li>
													


												</ul>
											</div>

										</nav>




									</div>

								</div>
							</div>
						</div>



					</header>
				</div>
				
		)
	}


export default Header  